import { CargoController } from "@/app/ui/controllers/CargoController";
import { ReadyToCargoController } from "@/app/ui/controllers/ReadyToCargoController";
import { CargoDetailStt, DimensionPerKoliData } from "@/domain/entities/Cargo";
import { Vue } from "vue-class-component";
import { CalculateVolumeApiRequest, CalculateVolumeRequest } from '@/data/payload/api/CargoApiRequest';
import { getConfigDimensionDivider, getConfigIsminimumVolumePerPiece, getConfigMinimumVolumePerPiece, CALCULATE_TYPE } from '../../modules/cargo-module';
import { parseByCountry } from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";

export default class CargoPlaneAutoV2 extends Vue {
  get isFeatureFlightV2Enable(): boolean {
    return !!(this.progress === 0 && this.listStt?.length);
  }

  get selectedCargoType(): boolean {
    return !!(this.isFeatureFlightV2Enable && this.isPlaneAuto);
  }

  get selectedCargoTypeV2BookingManual(): boolean {
    return !!(this.selectedCargoType && this.bookingManual);
  }

  get progress(): number {
    return CargoController.progressValue;
  }

  get bookingManual() {
    return ReadyToCargoController.flowBooking === "manual";
  }

  get form() {
    return CargoController.form;
  }

  get isPlaneAuto() {
    return (
      this.form.cargoType === "plane" && this.form.cargoTypeStatus === "auto"
    );
  }

  get listStt(): CargoDetailStt[] {
    return CargoController.sttResultFinal;
  }

  get disabledV2(): boolean {
    return (
      (this.selectedCargoType &&
        (CargoController.isErrorMaxGrossWeight ||
          CargoController.isErrorMaxVolumeWeight ||
          CargoController.isErrorMaxPieces)) ||
      this.disabledFormV2
    );
  }

  get disabledFormV2(): boolean {
    const {
      cargoProduct,
      actualTotalCargoGrossWeight,
      actualTotalCargoVolumeWeight,
      actualTotalSTTPieces
    } = this.form;

    return (
      !cargoProduct ||
      !actualTotalCargoGrossWeight ||
      !actualTotalCargoVolumeWeight ||
      !Number(actualTotalSTTPieces) ||
      this.disabledDimensionV2
    );
  }

  get disabledDimensionV2(): boolean {
    const { actualDimension } = this.form;

    return (
      !actualDimension?.width ||
      !actualDimension?.height ||
      !actualDimension?.length
    );
  }

  selectScheduleV2() {
    if (this.selectedCargoTypeV2BookingManual) {
      CargoController.setShowSelectAirport(true);
      CargoController.setShowSelectAirportToLocalStorage(true);
      return true;
    }
    return false;
  }

  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  validationBackV2() {
    if (this.selectedCargoTypeV2BookingManual) {
      const parseNumber = (value: string) => {
        if (typeof value === "number") return value;
        return parseByCountry(value, { country: this.countryCode });
      }
      CargoController.setDimensionPerKoliData(new DimensionPerKoliData());
      CargoController.setIsDimensionSaved(false);
      CargoController.setIsSttUpdated(false);
      CargoController.setCargoType({
        type: "",
        status: ""
      });
      CargoController.setShowSelectAirportToLocalStorage(false);
      CargoController.setShowModalCargoType(false);
      CargoController.calculateVolume(new CalculateVolumeApiRequest({
        calculateType: CALCULATE_TYPE.CHANGE_MODA,
        calculateRequest: new CalculateVolumeRequest({
          cargoType: this.form.cargoType,
          chargeableWeightReweigh: Math.max(1, CargoController.totalNewCalculationGrossWeights, CargoController.totalNewCalculationVolumeWeights),
          currentGrossWeight: parseNumber(this.form.actualTotalCargoGrossWeight),
          height: this.form.actualDimension.height,
          length: this.form.actualDimension.length,
          width: this.form.actualDimension.width,
          totalPieces: this.form.actualTotalSTTPieces,
          volumeWeightReweigh: parseNumber(CargoController.totalNewCalculationVolumeWeights as any),
          divider: getConfigDimensionDivider(this.form.cargoType),
          isMinimumVolumePerPiece: getConfigIsminimumVolumePerPiece(this.form.cargoType, this.form.cargoTypeStatus),
          minVolumePerPiece: getConfigMinimumVolumePerPiece(this.form.cargoType, this.form.cargoTypeStatus)
        })
      }))

      return true;
    }

    return false;
  }
}
